import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucNguyenVatLieuPhanLoai } from 'src/app/shared/DanhMucNguyenVatLieuPhanLoai.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucNguyenVatLieuPhanLoaiService extends BaseService{

    list: DanhMucNguyenVatLieuPhanLoai[] | undefined;
    list001: DanhMucNguyenVatLieuPhanLoai[] | undefined;
    formData!: DanhMucNguyenVatLieuPhanLoai;    

    displayColumns0001: string[] = ['STT', 'ID', 'ParentID', 'Code', 'Name', 'Note', 'SortOrder', 'IsChiPhi', 'Active', 'Save'];
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucNguyenVatLieuPhanLoai";
    }
}

